module.exports = __webpack_public_path__ + "static/media/kn.ad086c55.svg";